import './webpack.tweaks.ts';
import { createApp } from 'vue';
import WordpressBackendApp from './WordpressBackendApp.vue';

declare global {
  interface Window {
    wp: any;
  }
}

if (document.querySelector('#io-admin')) {
  createApp(WordpressBackendApp)
    .mount('#io-admin');
}
